import React from "react";
import ContentLoader from "react-content-loader";

const DashboardLoader = () => (
  <ContentLoader
    width="100%"
    height="207"
    viewBox="0 0 1280 207"
    backgroundColor="#687592"
    foregroundColor="#dbdbdb"
  >
    <rect x="0" y="0" rx="4" ry="4" width="295" height="207" />
    <rect x="325" y="0" rx="4" ry="4" width="295" height="207" />
    <rect x="650" y="0" rx="4" ry="4" width="295" height="207" />
    <rect x="975" y="0" rx="4" ry="4" width="295" height="207" />
  </ContentLoader>
);

DashboardLoader.metadata = {
  name: "Sridhar Easwaran",
  github: "sridhareaswaran",
  description: "Dashboard pages",
  filename: "DashboardLoader",
};

export default DashboardLoader;
